import React, { useState } from "react";
import { useContent } from "../i18n/LanguageContext";
import { Check, ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function ContactForm() {
  const contact = useContent().contact;
  const [form, setForm] = useState({ name: "", email: "", phone: "", amount: "", message: "" });

  const handle = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast.error(contact.toastErr);
      return;
    }
    const saved = JSON.parse(localStorage.getItem("barlow_leads") || "[]");
    saved.push({ ...form, at: new Date().toISOString() });
    localStorage.setItem("barlow_leads", JSON.stringify(saved));
    toast.success(contact.toastOk);
    setForm({ name: "", email: "", phone: "", amount: "", message: "" });
  };

  const inputCls =
    "w-full rounded-md border border-[#e7e2d8] bg-white px-4 py-3 text-sm text-[#16233d] placeholder-[#9aa0ad] focus:outline-none focus:border-[#b08d57] focus:ring-2 focus:ring-[#b08d57]/20 transition";

  return (
    <section id="kontakt" className="py-20 lg:py-28 bg-[#faf8f4]">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 items-center">
        <div className="reveal">
          <div className="eyebrow mb-4">{contact.eyebrow}</div>
          <h2 className="font-serif-lux text-4xl lg:text-5xl text-[#16233d] font-semibold leading-tight">{contact.title}</h2>
          <p className="mt-4 text-[#5c6577] text-lg">{contact.text}</p>
          <ul className="mt-8 space-y-3">
            {contact.perks.map((p) => (
              <li key={p} className="flex items-center gap-3 text-[#3a4258]">
                <span className="w-6 h-6 rounded-full bg-[#faf3e8] flex items-center justify-center">
                  <Check size={14} className="text-[#b08d57]" />
                </span>
                {p}
              </li>
            ))}
          </ul>
        </div>

        <form onSubmit={submit} className="bg-white rounded-2xl border border-[#efe9dd] p-8 shadow-[0_30px_60px_-40px_rgba(22,35,61,0.3)]">
          <div className="space-y-4">
            <input name="name" value={form.name} onChange={handle} placeholder={contact.form.name} className={inputCls} />
            <input name="email" type="email" value={form.email} onChange={handle} placeholder={contact.form.email} className={inputCls} />
            <input name="phone" value={form.phone} onChange={handle} placeholder={contact.form.phone} className={inputCls} />
            <input name="amount" value={form.amount} onChange={handle} placeholder={contact.form.amount} className={inputCls} />
            <textarea name="message" value={form.message} onChange={handle} placeholder={contact.form.message} rows={4} className={inputCls} />
          </div>
          <button type="submit" className="btn-gold rounded-md w-full py-3.5 font-medium mt-6 inline-flex items-center justify-center gap-2">
            {contact.form.submit} <ArrowRight size={17} />
          </button>
        </form>
      </div>
    </section>
  );
}
